import React, { Component } from 'react';
import history from '../shared/architecture/history'

const navigate = (props) => {
  props.selectable && !props.isVideo ?
    history.push('/' + props.target)
    :
    null
}

export default (props) => {
  const style = {}
  props.width ?
    style.width = props.width + '%'
    :
    null
  return (
    <div className={'pb5  ' + (props.selectable ? 'pointer grow' : '')}
      onClick={() => navigate(props)}>
      <div
        className=' ph2 '>
        <div className={'w-100 ' + (props.border ? 'b--light-gray ba' : '')}>
        {props.isVideo ?
          <video className='br3' width="100%" poster={props.poster} controls>
            <source src={props.image} type="video/mp4"/>
          Your browser does not support the video tag.
          </video>
        :
        <div className='center' style={style}>
          <img
            className='w-100 br3'
            src={props.image}
            alt="logo" />
          </div>
        }
      </div>
    </div>
      <div className='pl3 pr3 pt3 pb3 black '>
        <div
          className={'fw6 f4 f3-ns ' + props.align}
          onClick={()=>navigate(props)}>
          {props.headline}
        </div>

        <div className={' ' + props.align}>
          <h2 className='f5 fw4 fw3-ns blue mt1 mb1'>{props.tags}</h2>
        </div>
      </div>
    </div>
  )
}
